<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">CREA IMMAGINE</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_name" class="form-label label-fw">Name *</label>
                    <input  type="text" 
                            class="modal-input" 
                            id="imageModelCreate_name" 
                            [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                            placeholder="Name" 
                            formControlName="name">
                    <div class="invalid-feedback" *ngIf="formControls.name.touched">
                        <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                            Name is required
                        </span>
                    </div>
                </div>
            </div>
            <div class="col" [hidden]="true">
                <div class="m-3">
                    <label for="imageModelCreate_url" class="form-label label-fw">Url</label>
                    <input type="text" class="modal-input " id="imageModelCreate_url" placeholder="Url" formControlName="url">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_alt" class="form-label label-fw">Alt</label>
                    <input type="text" class="  modal-input " id="imageModelCreate_alt" placeholder="Alt" formControlName="alt">
                </div>
            </div>
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_summary" class="form-label label-fw">Summary</label>
                    <input type="text" class="  modal-input " id="imageModelCreate_summary" placeholder="Summary" formControlName="summary">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_tags" class="form-label label-fw">Tags</label>
                    <input type="text" class="  modal-input " id="imageModelCreate_tags" placeholder="Tags" formControlName="tags">
                </div>
            </div>
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_copyright" class="form-label label-fw">Copyright</label>
                    <input type="text" class="  modal-input " id="imageModelCreate_copyright" placeholder="Copyright" formControlName="copyright">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="m-3">
                    <label for="imageModelCreate_filename" class="form-label label-fw">File name</label>
                    <input id="filename"  class="  modal-input " type="text" formControlName="filename" disabled>
                </div>
            </div>
        </div>

        <!--drag&drop area-->
        <div class="row">
            <div class="col">
                <div class="drag-area d-flex m-3"  appDnd (fileDropped)="onFileDropped($event)">
                    <div class="icona justify-content-center">
                        <i class="fal fa-upload"></i>
                    </div>
                    <header>Drag&Drop here</header>
                    <span>or</span>
                    <button type="button" class="browse mb-3" (click)="fileUpload.click()"><i class="fas fa-folder-open"></i> Browse
                        file</button>
                    <input #fileUpload id="fileUpload" hidden type="file" (change)="onFileChange($event)" accept=".gif, .jpg, .png|image/*">
                    
                </div>
            </div>
        </div>

        <!--Anteprima-->
        <div class="row" [hidden]="files.length ===0?true:false">
            <div class="col">
                <div class="m-3" >
                    <h4>Anteprima</h4>
                </div>
            </div>
            <div class="col">
                <div class="m-3" >
                    <img src="{{filesSRC}}" class="img-thumbnail rounded mx-auto d-block" width="100%" height="auto" alt="Anteprima file">
                </div>
            </div>
        </div>




    </form>

    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">

            <button type="button" [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false "  class="btn btn-fw text me-3" (click)="clickButtonSave()">Salva modifiche</button>
            <button type="button" class="btn btn-outline-fw text" (click)="cancel()">Annulla</button>

        </div>
    </div>
</div>